import api from "./api";

// Documents a generated CV can carry behind it. Which of them a given CV gets is decided when it
// is generated, so nothing here stores that choice.

export const mapCvAttachmentDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    title: dto.title,
    fileName: dto.file_name,
    contentType: dto.content_type,
    fileSize: dto.file_size,
    sortOrder: dto.sort_order,
    createdAt: dto.created_at,
});

export const getCvAttachmentsForUser = async (userId) => {
    const res = await api.get(`/CvAttachment/${userId}`);
    return (res.data || []).map(mapCvAttachmentDto);
};

export const uploadCvAttachment = async (userId, file, title) => {
    const body = new FormData();
    body.append("file", file);
    if (title) body.append("title", title);
    const res = await api.post(`/CvAttachment/${userId}`, body);
    return res.data;
};

export const updateCvAttachment = async (attachmentId, payload) => {
    const res = await api.patch(`/CvAttachment/${attachmentId}`, payload);
    return res.data;
};

export const deleteCvAttachment = async (attachmentId) => {
    const res = await api.delete(`/CvAttachment/${attachmentId}`);
    return res.data;
};

// Same reason as the invoice preview: a tab navigation cannot send the API key, so the
// bytes are fetched here and the tab is pointed at a blob (see utils/pdfTab.js).
export const getCvAttachmentBlob = async (attachmentId) => {
    const res = await api.get(`/CvAttachment/${attachmentId}/file`, {responseType: "blob"});
    return res.data;
};
